import ArchivedPromotionLibrary from "./ArchivedPromotionLibrary";

export default ArchivedPromotionLibrary;